import { TFunction } from "react-i18next";

export const CACHE_TIME = 60 * 60 * 1000; // 1 hour
export const STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const STALE_TIME_OF_TWO_MINUTES = 2 * 60 * 1000; // 2 minutes
export const PRODUCTION_SHIPEEZI_MOVING_DEMO_COMPANY_ID = 2;

export const UNIT_OF_MEASURE_OPTIONS = (translate?: TFunction) => [
  { value: "Pieces", label: translate?.("pieces") || "" },
  { value: "Boxes", label: translate?.("boxes") || "" },
  { value: "Pairs", label: translate?.("pairs") || "" },
  { value: "Sets", label: translate?.("sets") || "" },
  { value: "Pallets", label: translate?.("pallets") || "" },
];
